import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { crmConstant } from "services/Crm/constant";
import {
  FormLabel,
  Grid,
  GridItem,
  Select as ChakraSelect,
  Text,
  Box,
  Button,
  Input,
  Textarea,
  Spinner,
} from "@chakra-ui/react";
import Select from "react-select";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import { useFormik } from "formik";

import { emailSchema } from "common/schema";
import { getApi, postApi } from "common/services/api";
import { constant } from "common/constant";
import { getDataFromStorage } from "common/utils/storage";
import { toast } from "react-toastify";
import { globalStyles } from "common/theme/styles";
import HTMLEditor from "common/components/richTextEditor/HTMLEditor";
import { useDispatch } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import { useSelector } from "react-redux";
import { fetchModuleData } from "common/redux/reducers/dynamicModuleSlice";

const EmailInformation = (props) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentToData, setAssignmentToData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const initialValuesPro = location.state?.initialValuesProp || {};
  const view = location.state?.view || "";
  const [relatedContacts, setRelatedContacts] = useState([]);
  const [files, setFiles] = useState([]);

  const initialValues = {
    sender: user?._id,
    recipient: initialValuesPro?.leadEmail
      ? initialValuesPro?.leadEmail
      : initialValuesPro?.email
      ? initialValuesPro?.email
      : initialValuesPro?.emailAddress
      ? initialValuesPro?.emailAddress
      : "",
    subject: "",
    callNotes: "",
    createBy:
      view === constant.contact && initialValuesPro?._id
        ? [initialValuesPro._id]
        : [],

    createByLead:
      view === constant.lead && initialValuesPro?._id
        ? [initialValuesPro._id]
        : [],
    startDate: new Date(),
    endDate: "",
    category:
      view === constant.lead
        ? constant.lead
        : view === constant.accounts
        ? constant.accounts
        : view === constant.deals
        ? constant.deals
        : constant.contact,
    ccRecipients: "",
    assignTo:
      view === constant.contact && initialValuesPro?._id
        ? [initialValuesPro._id]
        : [],
    createByAccount:
      view === constant.accounts && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    createByDeal:
      view === constant.deals && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: emailSchema,
    onSubmit: (values, { resetForm }) => {
      AddData(resetForm);
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async (resetForm) => {
    try {
      setIsLoading(true);
      const outlook_access_token = getDataFromStorage(
        constant.outlookAccessToken
      );
      const user = JSON.parse(localStorage.getItem("user"));

      if (user?.isGoogleAccountSynced) {
        const payload = {
          to: values?.recipient || "",
          subject: values?.subject || "",
          message: values?.message || "",
        };

        const response = await postApi("api/gmail/sendemail", payload); // Sends JSON by default

        if (response.status === 200) {
          toast.success(crmConstant.email_success);
          navigate(-1);
        }
      } else {
        const formData = new FormData();

        if (outlook_access_token) {
          formData.append("outlook_access_token", outlook_access_token);
        }

        for (const key in values) {
          if (values[key] !== undefined && values[key] !== null) {
            formData.append(key, values[key]);
          }
        }

        (files || []).forEach((file) => {
          formData.append("files", file);
        });

        const response = await postApi("api/email/add", formData);

        if (response.status === 200) {
          toast.success(crmConstant.email_success);
          navigate(-1);
        }
      }
    } catch (e) {
      console.error(e);
      toast.error(constant.something_went_wrong);
    } finally {
      setIsLoading(false);
      resetForm();
    }
  };
  const dispatch = useDispatch();
  const contacts = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const dynamicModules = useSelector((state) => state.dynamicModule.modules);

  useEffect(() => {
    if (values.category === "Contact") {
      setContactData(contacts);
      setAssignmentToData(contacts);
    } else if (values.category === "Lead") {
      setAssignmentToData(leadData);
    } else if (values.category === "Deals") {
      setAssignmentToData(dynamicModules?.Deals?.data);
    } else if (values.category === "Accounts") {
      setAssignmentToData(dynamicModules?.Accounts?.data);
    }
  }, [contacts, leadData, dynamicModules]);

  useEffect(() => {
    const fetchData = async () => {
      values.start = props?.date;
      try {
        let result;
        if (values.category === "Contact") {
          dispatch(getContactList({ fetchAllData: true }));
        } else if (values.category === "Lead") {
          dispatch(getLeadList({ fetchAllData: true }));
        } else if (["Deals", "Accounts"].includes(values.category)) {
          const res = await getApi(
            `api/custom-field/?moduleName=${values.category}`
          );
          const matchedModule = res?.data?.find(
            (item) => item?.moduleName === values.category
          );

          if (!matchedModule?._id) {
            toast.error(`No module found for ${values.category}`);
            return;
          }

          await dispatch(
            fetchModuleData({
              moduleId: matchedModule?._id,
              fetchAllData: true,
              type: values.category,
            })
          );
        }
      } catch (e) {
        console.error(e);
        toast.error("Something went wrong");
      }
    };

    fetchData();
  }, [props?.date, values.category]);

  const fetchRecipientData = async () => {
    if (values.createBy && values.createBy.length > 0) {
      const emails = [];
      for (const id of values.createBy) {
        const response = await getApi("api/contact/view/", id);
        if (response?.status === 200) {
          emails.push(response?.data?.contact?.email);
        }
      }
      setFieldValue("recipient", emails.join(", "));
      values.recipient = emails.join(", ");
    } else if (values.createByLead && values.createByLead.length > 0) {
      const emails = [];
      for (const id of values.createByLead) {
        const response = await getApi("api/lead/view/", id);
        if (response?.status === 200) {
          emails.push(response?.data?.lead?.leadEmail);
        }
      }
      setFieldValue("recipient", emails.join(", "));
      values.recipient = emails.join(", ");
    }
  };

  useEffect(() => {
    fetchRecipientData();
  }, [values.createBy, values.createByLead]);
  const handleBackPage = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (!values.assignTo?.length || !assignmentToData?.length) return;

    const selectedItems = assignmentToData.filter((item) =>
      values.assignTo.includes(item._id)
    );

    if (values.category === "Contact") {
      const selectedEmails = selectedItems.map((item) => item.email);
      setFieldValue("recipient", selectedEmails.join(", "));
      setFieldValue("createBy", values.assignTo);
    } else {
      const selectedIds = selectedItems.map((item) => item._id);
      const selectedEmails = selectedItems.map((item) => item.leadEmail);
      setFieldValue("createByLead", selectedIds);
      setFieldValue("recipient", selectedEmails.join(", "));
    }
  }, [values.category, values.assignTo, assignmentToData, setFieldValue]);

  return (
    <>
      <Box className="commonPanelBody">
        <ContactModel
          isOpen={contactModelOpen}
          data={assignmentToData}
          onClose={setContactModel}
          fieldName="createBy"
          setFieldValue={setFieldValue}
        />
        {/* Lead Model  */}
        <LeadModel
          isOpen={leadModelOpen}
          data={assignmentToData}
          onClose={setLeadModel}
          fieldName="createByLead"
          setFieldValue={setFieldValue}
        />

        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.related}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                const category = e.target.value;
                setFieldValue("category", category);
                setFieldValue("createBy", []);
                setFieldValue("createByLead", []);
                setFieldValue("recipient", "");
                setFieldValue("assignTo", []);
                setFieldValue("ccRecipients", "");
                setFieldValue("ccAssignTo", []);
                setFieldValue("email", "");
                setFieldValue("ccEmail", "");
                setRelatedContacts([]);
                setFieldValue("createByDeal", "");
                setFieldValue("createByAccount", "");
              }}
              value={values.category}
            >
              <option value="Contact">Contact</option>
              <option value="Lead">Lead</option>
              <option value="Accounts">{constant.account}</option>
              <option value="Deals">{constant.deal}</option>
            </ChakraSelect>
            <Text mb="10px" fontSize="sm" color={"red"}>
              {errors.category && touched.category && errors.category}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.dateAndTime}
            </FormLabel>
            <Input
              type="datetime-local"
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.startDate}
              name="startDate"
              fontWeight="500"
              borderColor={
                errors?.startDate && touched?.startDate ? "red.300" : null
              }
            />
            <Text fontSize="sm" mb="10px" color={"red"}>
              {" "}
              {errors.startDate && touched.startDate && errors.startDate}
            </Text>
          </GridItem>
          {values.category === "Contact" ? (
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.recipientContact}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Select
                isMulti
                onChange={(selectedOption) => {
                  const selectedValue = selectedOption.map(
                    (option) => option.value
                  );
                  const selectedValueEmail = selectedOption.map(
                    (option) => option.email
                  );

                  setFieldValue("recipient", selectedValueEmail.join(", "));
                  setFieldValue("assignTo", selectedValue);
                  setFieldValue("createBy", selectedValue);
                }}
                placeholder={"Assign To"}
                name="assignTo"
                options={
                  assignmentToData?.map((item) => ({
                    value: item._id,
                    label: item.contactName,
                    email: item.email,
                  })) || []
                }
                className="basic-multi-select"
                classNamePrefix="select"
                value={(assignmentToData || [])
                  .filter((item) => values.createBy?.includes(item._id))
                  .map((item) => ({
                    value: item._id,
                    label: item.contactName,
                    email: item.email,
                  }))}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {errors.recipient && touched.recipient && errors.recipient}
              </Text>
            </GridItem>
          ) : values.category === "Lead" ? (
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.recipientLead}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Select
                defaultValue={null}
                isMulti
                onChange={(selectedOption) => {
                  const selectedValue = selectedOption.map(
                    (option) => option.value
                  );
                  const selectedValueEmail = selectedOption.map(
                    (option) => option.email
                  );

                  setFieldValue("recipient", selectedValueEmail.join(", "));
                  setFieldValue("assignTo", selectedValue);
                  setFieldValue("createByLead", selectedValue);
                }}
                placeholder={"Assign To"}
                name="assignTo"
                options={
                  assignmentToData?.map((item) => ({
                    value: item._id,
                    label: item.leadName,
                    email: item.leadEmail,
                  })) || []
                }
                className="basic-multi-select"
                classNamePrefix="select"
                value={(assignmentToData || [])
                  .filter((item) => values.createByLead?.includes(item._id))
                  .map((item) => ({
                    value: item._id,
                    label: item.leadName,
                    email: item.leadEmail,
                  }))}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {errors.recipient && touched.recipient && errors.recipient}
              </Text>
            </GridItem>
          ) : (
            ""
          )}
          {(values.category === "Accounts" || values.category === "Deals") && (
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                fontSize="sm"
                fontWeight="500"
                mb="8px"
                display="flex"
                alignItems="center"
                gap="1"
              >
                {crmConstant.recipient} (
                {values.category === "Accounts"
                  ? constant.accounts
                  : constant.deals}
                )
                <Text as="span" color="red">
                  *
                </Text>
              </FormLabel>

              <ChakraSelect
                value={
                  values.category === "Accounts"
                    ? values.createByAccount || ""
                    : values.createByDeal || ""
                }
                name={
                  values.category === "Accounts"
                    ? "createByAccount"
                    : "createByDeal"
                }
                onChange={(e) => {
                  const selectedValue = e.target.value;

                  if (values.category === "Accounts") {
                    setFieldValue("createByAccount", selectedValue);
                  } else {
                    setFieldValue("createByDeal", selectedValue);
                  }

                  const matchedItem = assignmentToData.find(
                    (item) => item._id === selectedValue
                  );
                  const contactIds = matchedItem?.contact?.map(String) || [];
                  const matchedContacts = contactData
                    .filter((c) => contactIds.includes(String(c._id)))
                    .map((contact) => ({
                      value: contact._id,
                      label: contact.contactName || "-",
                      email: contact?.email || "",
                    }));
                  setRelatedContacts(matchedContacts);
                }}
                placeholder={crmConstant.assignTo}
                fontWeight="500"
                borderColor="gray.200"
              >
                {assignmentToData?.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.label || item.dealName || item.accountName || "-"}
                  </option>
                ))}
              </ChakraSelect>
              <Text mb="10px" fontSize="sm" color={"red"}>
                {(values.category === "Accounts" && errors.createByAccount) ||
                  (values.category === "Deals" && errors.createByDeal)}
              </Text>
            </GridItem>
          )}

          {/* Related Contacts */}
          {relatedContacts.length > 0 && (
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                fontSize="sm"
                fontWeight="500"
                mb="8px"
                display="flex"
                alignItems="center"
                gap="1"
              >
                Select Contacts from {values.category}
                <Text as="span" color="red">
                  *
                </Text>
              </FormLabel>
              <Select
                isMulti
                placeholder="Select related contacts"
                name="createBy"
                options={relatedContacts}
                value={relatedContacts.filter((item) =>
                  values.createBy?.includes(item.value)
                )}
                onChange={(selected) => {
                  const selectedArray = Array.isArray(selected)
                    ? selected
                    : selected
                    ? [selected]
                    : [];
                  const selectedContactIds = selectedArray.map(
                    (item) => item.value
                  );
                  setFieldValue("createBy", selectedContactIds);
                  console.log(selectedContactIds, "selectedContactIds");

                  const selectedEmail =
                    relatedContacts.find(
                      (contact) => contact.value === selectedContactIds[0]
                    )?.email || "";

                  setFieldValue("recipient", selectedEmail);
                }}
                className="basic-multi-select"
                classNamePrefix="select"
              />
              <Text mb="10px" color="red.600" fontSize="sm">
                {errors.createBy && touched.createBy && errors.createBy}
              </Text>
            </GridItem>
          )}
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.emails}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              readOnly
              value={values.recipient}
              name="recipient"
              placeholder={crmConstant.emails}
              fontWeight="500"
            />
          </GridItem>

          {values.category === "Contact" ? (
            <>
              {/* CC Recipient Field */}
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.ccRecipientContact}
                </FormLabel>
                <Select
                  defaultValue={null}
                  isMulti
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption.map(
                      (option) => option.value
                    );
                    const selectedValueEmail = selectedOption.map(
                      (option) => option.email
                    );
                    setFieldValue(
                      "ccRecipients",
                      selectedValueEmail.join(", ")
                    );
                    setFieldValue("ccAssignTo", selectedValue);
                  }}
                  value={(assignmentToData || [])
                    .filter((item) => values.ccAssignTo?.includes(item._id))
                    .map((item) => ({
                      value: item._id,
                      label:
                        values.category === "Contact"
                          ? `${item.contactName}`
                          : item.leadName,
                      email:
                        values.category === "Contact"
                          ? item.email
                          : item.leadEmail,
                    }))}
                  placeholder={"Assign To (CC)"}
                  name="ccAssignTo"
                  options={
                    assignmentToData?.map((item) => ({
                      value: item._id,
                      label:
                        values.category === "Contact"
                          ? `${item.contactName}`
                          : item.leadName,
                      email:
                        values.category === "Contact"
                          ? item.email
                          : item.leadEmail,
                    })) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </GridItem>
            </>
          ) : values.category === "Lead" ? (
            <>
              {/* CC Recipient Field */}
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.ccRecipientLead}
                </FormLabel>
                <Select
                  defaultValue={null}
                  isMulti
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption.map(
                      (option) => option.value
                    );
                    const selectedValueEmail = selectedOption.map(
                      (option) => option.email
                    );
                    setFieldValue(
                      "ccRecipients",
                      selectedValueEmail.join(", ")
                    );
                    setFieldValue("ccAssignTo", selectedValue);
                  }}
                  value={(assignmentToData || [])
                    .filter((item) => values.ccAssignTo?.includes(item._id))
                    .map((item) => ({
                      value: item._id,
                      label:
                        values.category === "Contact"
                          ? `${item.contactName}`
                          : item.leadName,
                      email:
                        values.category === "Contact"
                          ? item.email
                          : item.leadEmail,
                    }))}
                  placeholder={"Assign To (CC)"}
                  name="ccAssignTo"
                  options={
                    assignmentToData?.map((item) => ({
                      value: item._id,
                      label:
                        values.category === "Contact"
                          ? `${item.contactName}`
                          : item.leadName,
                      email:
                        values.category === "Contact"
                          ? item.email
                          : item.leadEmail,
                    })) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </GridItem>
            </>
          ) : (
            ""
          )}

          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.ccEmails}
            </FormLabel>
            <Input
              fontSize="sm"
              readOnly
              value={values.ccRecipients}
              name="ccRecipients"
              placeholder={crmConstant.ccEmails}
              fontWeight="500"
              borderColor={
                errors.ccRecipients && touched.ccRecipients ? "red.300" : null
              }
            />
          </GridItem>
          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.subject}
              {/* <Text color={"red"}>*</Text> */}
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.subject}
              name="subject"
              placeholder={crmConstant.subject}
              fontWeight="500"
              borderColor={errors.subject && touched.subject ? "red.300" : null}
            />
            <Text fontSize="sm" mb="10px" color={"red"}>
              {" "}
              {errors.subject && touched.subject && errors.subject}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.emailBody}
            </FormLabel>
            {/* <Textarea
              resize={"none"}
              fontSize="sm"
              placeholder="Type Here..."
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.message}
              name="message"
              fontWeight="500"
              borderColor={errors.message && touched.message ? "red.300" : null}
            /> */}
            <HTMLEditor
              value={values.message || ""}
              onChange={(content) => {
                setFieldValue("message", content);
              }}
              onFilesChange={(files) => setFiles(files)}
            />
            <Text fontSize="sm" mb="10px" color={"red"}>
              {" "}
              {errors.message && touched.message && errors.message}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.discard}
        </Button>
        <Button
          variant="brand"
          size="sm"
          disabled={isLoading ? true : false}
          onClick={handleSubmit}
          className="theme-btn1"
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.send}
        </Button>
      </Box>
    </>
  );
};

const CreateEmail = () => {
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [
    { label: crmConstant.emailInformation, Icon: JobOpeningIcon },
  ];

  const panelsData = [<EmailInformation />];

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createEmail}
    />
  );
};

export default CreateEmail;
